export const batteryDto = (mockData) => {
  return mockData.map((item) => ({
    codigo: item.codigo,
    stock: item.stock,
    marca: item.marca,
    trimarca: item.trimarca,
    carPlate: item.carPlate,
    valor_por_defecto_plp_simple: item.valor_por_defecto_plp_simple,
    valor_por_defecto_plp_doble: item.valor_por_defecto_plp_doble,
    valor_max_plp_simple: item.valor_max_plp_simple,
    valor_max_plp_doble: item.valor_max_plp_doble,
    icono_marca: item.icono_marca,
    precio_lista: item.precio_lista,
    precio_venta: item.precio_venta,
    precio_venta_web: item.precio_venta_web,
    precio_venta_local: item.precio_venta_local,
    precio_venta_tmk: item.precio_venta_tmk,
    markup: item.markup,
    precio_tachado: item.precio_tachado,
    diseno: item.descripcion,
    ah: item.ah,
    rc: item.rc,
    cca: item.cca,
    descripcion: item.descripcion,
    descripcion_emocional: item.descripcion_emocional,
    imagen_performance: item.imagen_performance,
    caracteristicas: item.caracteristicas.map((feature) => ({
      name: feature.nombre,
      value: feature.valor,
    })),
    info_vehiculo: item.info_vehiculo,
    icono_garantia_leon: item.icono_garantia_leon,
    texto_garantia_leon: item.texto_garantia_leon,
    icono_garantia_fabrica: item.icono_garantia_fabrica,
    texto_garantia_fabrica: item.texto_garantia_fabrica,
    banderin_garantia_leon: item.banderin_garantia_leon,
    icono_banderin_garantia_leon: item.icono_banderin_garantia_leon,
    banderin_garantia_fabrica: item.banderin_garantia_fabrica,
    icono_banderin_garantia_fabrica: item.icono_banderin_garantia_fabrica,
    icono_precio_internet: item.icono_precio_internet,
    promociones: item.promociones,

    photos: item.fotos.map((photo) => ({
      frente: photo.frente || null,
      diagonal: photo.frente || null,
      lado: photo.lado || null,
      detalle: photo.detalle || null,
      surco: photo.surco || null,
    })),
    rrss: item.rrss.map((social) => ({
      link_facebook: social.link_facebook,
      icono_facebook: social.icono_facebook,
      link_twitter: social.link_twitter,
      icono_twitter: social.icono_twitter,
      link_whatsapp: social.link_whatsapp,
      icono_whatsapp: social.icono_whatsapp,
    })),
  }));
};

export const batteryPdpDto = (item) => ({
  audio_marca: item.audio_marca,
  codigo: item.codigo,
  stock: item.stock,
  marca: item.marca,
  trimarca: item.trimarca,
  carPlate: item.carPlate,
  valor_por_defecto_plp_simple: item.valor_por_defecto_plp_simple,
  valor_por_defecto_plp_doble: item.valor_por_defecto_plp_doble,
  valor_max_plp_simple: item.valor_max_plp_simple,
  valor_max_plp_doble: item.valor_max_plp_doble,
  icono_marca: item.icono_marca,
  precio_lista: item.precio_lista,
  precio_venta: item.precio_venta,
  precio_venta_web: item.precio_venta,
  precio_venta_local: item.precio_venta_local,
  precio_venta_tmk: item.precio_venta_tmk,
  markup: item.markup,
  precio_tachado: item.precio_tachado,
  diseno: item.descripcion,
  ah: item.ah,
  rc: item.rc,
  cca: item.cca,
  descripcion: item.descripcion,
  descripcion_emocional: item.descripcion_emocional,
  descripcion_emocional_marca: item.descripcion_emocional_marca,
  imagen_performance: item.imagen_performance,
  caracteristicas: item.caracteristicas.map((feature) => ({
    name: feature.nombre,
    value: feature.valor,
  })),
  icono_speaker: item.icono_speaker,
  icono_garantia_leon: item.icono_garantia_leon,
  texto_garantia_leon: item.texto_garantia_leon,
  icono_garantia_fabrica: item.icono_garantia_fabrica,
  texto_garantia_fabrica: item.texto_garantia_fabrica,
  banderin_garantia_leon: item.banderin_garantia_leon,
  icono_banderin_garantia_leon: item.icono_banderin_garantia_leon,
  banderin_garantia_fabrica: item.banderin_garantia_fabrica,
  icono_banderin_garantia_fabrica: item.icono_banderin_garantia_fabrica,
  icono_precio_internet: item.icono_precio_internet,
  promociones: item.promociones,
  photos: item.fotos.map((photo) => ({
    frente: photo.frente || null,
    diagonal: photo.frente || null,
    lado: photo.lado || null,
    detalle: photo.detalle || null,
    surco: photo.surco || null,
  })),
  rrss: item.rrss.map((social) => ({
    link_facebook: social.link_facebook,
    icono_facebook: social.icono_facebook,
    link_twitter: social.link_twitter,
    icono_twitter: social.icono_twitter,
    link_whatsapp: social.link_whatsapp,
    icono_whatsapp: social.icono_whatsapp,
  })),
});

export const mockResponse = [
  {
    codigo: "1415570T1",
    stock: 5,
    marca: "ACDELCO",
    trimarca: "NO",
    carPlate: "BB1234",
    valor_por_defecto_plp_simple: 4,
    valor_por_defecto_plp_doble: 2,
    valor_max_plp_simple: 5,
    valor_max_plp_doble: 2,
    icono_marca:
      "https://qa-leon-baterias.borealis.cl/img/plp/brand-battery.png",
    precio_lista: 27000,
    precio_venta_web: 53550,
    precio_venta_local: 60390,
    precio_venta_tmk: 56370,
    markup: 0,
    precio_tachado: null,
    diseno: "ACDelco NS40ZL",
    ah: 60,
    rc: 63,
    cca: 550,
    descripcion: "155/70R14 X-PRIVILO TX5 77T",
    descripcion_emocional:
      "Batería de auto HANKOOK MF55D23L de 60AH y 550CCA es uno de los elementos imprescindibles en todo vehículo. Cumple la función de almacenar la energía eléctrica para luego ser transmitida al motor de partida cada vez que quieras arrancar. Nuestro producto es una batería húmeda rellena de ácido, sellada y 100% libre de mantención. También cuenta con tecnología ''X-Frame'', la que otorga un alto rendimiento optimizando el flujo eléctrico interno de la batería junto con aumentar la durabilidad, haciéndola más resistente contra las vibraciones del motor.Sus 550 CCA hacen de esta la mejor opción de compra a la hora de elegir una nueva batería para tu automóvil.",
    imagen_performance: "img/plp/battery.png",
    caracteristicas: [
      {
        nombre: "Marca",
        valor: "ACDELCO",
      },
      {
        nombre: "Norma",
        valor: "JIS",
      },
      {
        nombre: "Amperes Horas (AH)",
        valor: "60",
      },
      {
        nombre: "Reserva de carga (RC)",
        valor: "63",
      },
      {
        nombre: "Amperes arranque en frío (CCA)",
        valor: "550",
      },
      {
        nombre: "Tipo borne",
        valor: "Estándar",
      },
      {
        nombre: "Ubicación",
        valor: "Derecho",
      },
      {
        nombre: "Base",
        valor: "",
      },
      {
        nombre: "Ventilation",
        valor: "",
      },
      {
        nombre: "País",
        valor: "Corea",
      },
      {
        nombre: "Ancho de caja (cm)",
        valor: "18",
      },
      {
        nombre: "Altura de caja (cm)",
        valor: "22",
      },
      {
        nombre: "Longitud de caja (cm)",
        valor: "23",
      },
      {
        nombre: "Peso bruto de caja (kg)",
        valor: "16.85",
      },

      {
        nombre: "Terminal",
        valor: "A",
      },
      {
        nombre: "Tipo de pestaña",
        valor: "B0",
      },
      {
        nombre: "Garantía",
        valor: "24 meses",
      },
    ],
    icono_garantia_leon:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_garantia_leon_NO.png",
    texto_garantia_leon: "",
    icono_garantia_fabrica:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_garantia_fabrica_NO.png",
    texto_garantia_fabrica: "",
    banderin_garantia_leon: "NO",
    icono_banderin_garantia_leon:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_banderin_garantia_leon_NO.png",
    banderin_garantia_fabrica: "NO",
    icono_banderin_garantia_fabrica:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_banderin_garantia_fabrica_NO.png",
    icono_precio_internet:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_precio_internet.svg",
    promociones: null,
    fotos: [
      {
        diagonal:
          "https://qa-leon-baterias.borealis.cl/img/plp/bateria-lado.jpg",
      },
    ],
    rrss: [
      {
        link_facebook:
          "https://www.facebook.com/sharer/sharer.php?u=https://neumaticos.leon.cl/pdp/1415570T1",
        icono_facebook:
          "https://backoffice1946.leon.cl/iconos_neumatico/rrss/facebook.svg",
        link_twitter:
          "https://twitter.com/intent/tweet?url=https://neumaticos.leon.cl/pdp/1415570T1&text=TRACMAX%20X-PRIVILO%20TX5%20155/70%20R14%2077T",
        icono_twitter:
          "https://backoffice1946.leon.cl/iconos_neumatico/rrss/twitter-x.svg",
        link_whatsapp:
          "https://api.whatsapp.com/send?text=https://neumaticos.leon.cl/pdp/1415570T1",
        icono_whatsapp:
          "https://backoffice1946.leon.cl/iconos_neumatico/rrss/whatsapp.svg",
      },
    ],
  },

  {
    codigo: "1415570T2",
    stock: 5,
    marca: "ACDELCOFF",
    trimarca: "NO",
    carPlate: "BB1234",
    valor_por_defecto_plp_simple: 4,
    valor_por_defecto_plp_doble: 2,
    valor_max_plp_simple: 5,
    valor_max_plp_doble: 2,
    icono_marca:
      "https://qa-leon-baterias.borealis.cl/img/plp/brand-battery.png",
    precio_lista: 20000,
    precio_venta_web: 50550,
    precio_venta_local: 50390,

    precio_venta_tmk: 50370,
    markup: 0,
    precio_tachado: null,
    diseno: "Acdelcoff NS40ZL",
    ah: 50,
    rc: 62,
    cca: 500,
    descripcion: "155/70R14 X-PRIVILO TX5 77T",
    descripcion_emocional:
      "Batería de auto HANKOOK MF55D23L de 60AH y 550CCA es uno de los elementos imprescindibles en todo vehículo. Cumple la función de almacenar la energía eléctrica para luego ser transmitida al motor de partida cada vez que quieras arrancar. Nuestro producto es una batería húmeda rellena de ácido, sellada y 100% libre de mantención. También cuenta con tecnología ''X-Frame'', la que otorga un alto rendimiento optimizando el flujo eléctrico interno de la batería junto con aumentar la durabilidad, haciéndola más resistente contra las vibraciones del motor.Sus 550 CCA hacen de esta la mejor opción de compra a la hora de elegir una nueva batería para tu automóvil.",
    imagen_performance: "img/plp/battery.png",
    caracteristicas: [
      {
        nombre: "Marca",
        valor: "ACDELCOFF",
      },
      {
        nombre: "Norma",
        valor: "JISD",
      },
      {
        nombre: "Amperes Horas (AH)",
        valor: 65,
      },
      {
        nombre: "Reserva de carga (RC)",
        valor: 62,
      },
      {
        nombre: "Amperes arranque en frío (CCA)",
        valor: 500,
      },
      {
        nombre: "Tipo borne",
        valor: "Estándar",
      },
      {
        nombre: "Ubicación",
        valor: "Izquierdo",
      },
      {
        nombre: "Base",
        valor: "",
      },
      {
        nombre: "Ventilation",
        valor: "",
      },
      {
        nombre: "País",
        valor: "Corea",
      },
      {
        nombre: "Ancho de caja (cm)",
        valor: 18,
      },
      {
        nombre: "Altura de caja (cm)",
        valor: 22,
      },
      {
        nombre: "Longitud de caja (cm)",
        valor: 23,
      },
      {
        nombre: "Peso bruto de caja (kg)",
        valor: 16.85,
      },

      {
        nombre: "Terminal",
        valor: "A",
      },
      {
        nombre: "Tipo de pestaña",
        valor: "B0",
      },
      {
        nombre: "Garantía",
        valor: "24 meses",
      },
    ],

    icono_garantia_leon:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_garantia_leon.png",
    texto_garantia_leon: "",
    icono_garantia_fabrica:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_garantia_fabrica.png",
    texto_garantia_fabrica: "",
    banderin_garantia_leon: "SI",
    icono_banderin_garantia_leon:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_banderin_garantia_leon_NO.png",
    banderin_garantia_fabrica: "SI",
    icono_banderin_garantia_fabrica:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_banderin_garantia_fabrica_NO.png",
    icono_precio_internet:
      "https://backoffice1946.leon.cl/iconos_neumatico/icono_precio_internet.svg",
    promociones: null,

    fotos: [
      {
        diagonal:
          "https://qa-leon-baterias.borealis.cl/img/plp/bateria-lado.jpg",
      },
    ],
    rrss: [
      {
        link_facebook:
          "https://www.facebook.com/sharer/sharer.php?u=https://neumaticos.leon.cl/pdp/1415570T1",
        icono_facebook:
          "https://backoffice1946.leon.cl/iconos_neumatico/rrss/facebook.svg",
        link_twitter:
          "https://twitter.com/intent/tweet?url=https://neumaticos.leon.cl/pdp/1415570T1&text=TRACMAX%20X-PRIVILO%20TX5%20155/70%20R14%2077T",
        icono_twitter:
          "https://backoffice1946.leon.cl/iconos_neumatico/rrss/twitter-x.svg",
        link_whatsapp:
          "https://api.whatsapp.com/send?text=https://neumaticos.leon.cl/pdp/1415570T1",
        icono_whatsapp:
          "https://backoffice1946.leon.cl/iconos_neumatico/rrss/whatsapp.svg",
      },
    ],
  },
];

export const mockServicesResponse = [
  {
    obligatorios: [
      {
        codigo: "INST001",
        nombre: "Instalaci\u00f3n",
        orden: 1,
        por_bateria: "SI",
        gratis: "SI",
        precio_unitario: 0,
        conoce_mas_titulo: "¿Qué es la instalación?",
        conoce_mas_descripcion:
          "En León siempre realizamos el montaje de los neumáticos que vendemos, pues queremos asegurar que el trabajo quede bien hecho y así no se produzcan accidentes y así podrás hacer valer tu garantía",
        conoce_mas_video:
          "https://backoffice1946.leon.cl/servicios/MON001/video.mp4",
      },
      {
        codigo: "ECO001",
        nombre: "Ecotasa",
        orden: 2,
        por_bateria: "SI",
        gratis: "NO",
        precio_unitario: 990,
        conoce_mas_titulo: "Ecotasa",
        conoce_mas_descripcion:
          "Con la Ecotasa contribuyes a darle una nueva oportunidad a tus baterías viejas, a trav\u00e9s del reciclaje.  En LE\u00d3N aseguramos una disposici\u00f3n final para aseguramos de que las baterías que recibimos se transformen en materia prima para ser utilizados en productos terminados, como pasto artificial, mezclas asf\u00e1lticas, palmetas de pisos, juegos infantiles, plazas, canchas deportivas y veredas.",
        conoce_mas_video:
          "https://backoffice1946.leon.cl/servicios/ECO001/video.mp4",
      },
    ],
    opcionales: [
      {
        codigo: "RTP",
        nombre: "Revisi\u00f3n de Seguridad",
        orden: 4,
        por_bateria: "NO",
        gratis: "SI",
        precio_unitario: 0,
        conoce_mas_titulo: "Revisi\u00f3n de Seguridad",
        conoce_mas_descripcion:
          "Cada cierta distancia recorrida, es necesario hacer un chequeo de las piezas y funcionamiento del auto. En LE\u00d3N hacemos un diagn\u00f3stico gratuito y, si es necesario, recomendamos realizar alg\u00fan recambio o reparaci\u00f3n. Es importante efectuar una revisi\u00f3n peri\u00f3dica y preventiva del veh\u00edculo para evitar accidentes o desperfectos mayores.",
        conoce_mas_video:
          "https://backoffice1946.leon.cl/servicios/RTP/video.mp4",
      },

      {
        codigo: "RDN",
        nombre: "Revisi\u00f3n de niveles",
        orden: 5,
        por_bateria: "NO",
        gratis: "SI",
        precio_unitario: 0,
        conoce_mas_titulo: "Revisi\u00f3n de niveles",
        conoce_mas_descripcion:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Vivamus vel orci a nunc lacinia congue. Ut ac quam sit amet nisl elementum venenatis. Fusce malesuada, velit non tempus laoreet, sapien est vulputate ligula, non accumsan libero odio sed augue. Suspendisse potenti. Etiam vitae.",
        conoce_mas_video:
          "https://backoffice1946.leon.cl/servicios/RTP/video.mp4",
      },
    ],
    recomendados: [
      {
        codigo: "GEXT",
        nombre: "Garant\u00eda Extendida 6 Meses Adicionales",
        orden: 3,
        por_bateria: "SI",
        gratis: "NO",
        precio_unitario: 5000,
        conoce_mas_titulo: "Garant\u00eda Extendida 6 Meses Adicionales",
        conoce_mas_descripcion:
          "\u00a1Aumenta la tranquilidad en cada kil\u00f3metro! Con nuestra Garant\u00eda Extendida de 6 Meses, tus neum\u00e1ticos estar\u00e1n protegidos contra cualquier da\u00f1o irreparable que pueda ocurrir en la carretera. Este beneficio cubre todo tipo de eventos, brindando una protecci\u00f3n adicional a la garant\u00eda que ya ofrece la marca de tus neum\u00e1ticos. Porque sabemos que los imprevistos ocurren, con esta garant\u00eda te aseguramos que estar\u00e1s cubierto para que sigas tu camino sin preocupaciones.",
        conoce_mas_video:
          "https://backoffice1946.leon.cl/servicios/GEXT/video.mp4",
      },
    ],
  },
];

export const servicesDto = (mockData) => {
  const [data] = mockData;
  return {
    obligatorios: data.obligatorios.map((service) => ({
      codigo: service.codigo,
      nombre: service.nombre,
      orden: service.orden,
      por_bateria: service.por_bateria,
      gratis: service.gratis,
      precio_unitario: service.precio_unitario,
      conoce_mas_titulo: service.conoce_mas_titulo,
      conoce_mas_descripcion: service.conoce_mas_descripcion,
      conoce_mas_video: service.conoce_mas_video,
    })),
    opcionales: data.opcionales.map((service) => ({
      codigo: service.codigo,
      nombre: service.nombre,
      orden: service.orden,
      por_bateria: service.por_bateria,
      gratis: service.gratis,
      precio_unitario: service.precio_unitario,
      conoce_mas_titulo: service.conoce_mas_titulo,
      conoce_mas_descripcion: service.conoce_mas_descripcion,
      conoce_mas_video: service.conoce_mas_video,
    })),
    recomendados: data.recomendados.map((service) => ({
      codigo: service.codigo,
      nombre: service.nombre,
      orden: service.orden,
      por_bateria: service.por_bateria,
      gratis: service.gratis,
      precio_unitario: service.precio_unitario,
      conoce_mas_titulo: service.conoce_mas_titulo,
      conoce_mas_descripcion: service.conoce_mas_descripcion,
      conoce_mas_video: service.conoce_mas_video,
    })),
  };
};

export const mockLogisticsResponse = [
  {
    cabecera: {
      puede_venir_ahora: "SI",
      local_id: "10",
      local_alias: "puertomontt",
      tiempo_estimado: 0,
      productos_en_tienda: "SI",
      baterias: [
        {
          codigo: "1415570T1",
          cantidad: "4",
        },
      ],
    },
    logistica: [
      {
        codigo: "1415570T1",
        cantidad: 4,
        tiempo_estimado: 0,
        saldo: 0,
        faltan_baterias: "NO",
        productos_en_tienda: "SI",
        detalle: [
          {
            local: "puertomontt",
            tipo: "LOCAL",
            tiempo: 0,
            cantidad: 4,
          },
        ],
      },
    ],
  },
];

export const mockLogisticsNoResponse = [
  {
    cabecera: {
      puede_venir_ahora: "NO",
      local_id: "10",
      local_alias: "puertomontt",
      tiempo_estimado: 0,
      productos_en_tienda: "NO",
      baterias: [
        {
          codigo: "1415570T1",
          cantidad: "4",
        },
      ],
    },
    logistica: [
      {
        codigo: "1415570T1",
        cantidad: 4,
        tiempo_estimado: 0,
        saldo: 0,
        faltan_baterias: "NO",
        productos_en_tienda: "NO",
        detalle: [
          {
            local: "puertomontt",
            tipo: "LOCAL",
            tiempo: 0,
            cantidad: 4,
          },
        ],
      },
    ],
  },
];

export const logisticsDto = (mockData) => {
  const [data] = mockData;
  return {
    cabecera: {
      puede_venir_ahora: data.cabecera.puede_venir_ahora,
      local_id: data.cabecera.local_id,
      local_alias: data.cabecera.local_alias,
      tiempo_estimado: data.cabecera.tiempo_estimado,
      productos_en_tienda: data.cabecera.productos_en_tienda,
      baterias: data.cabecera.baterias.map((bateria) => ({
        codigo: bateria.codigo,
        cantidad: bateria.cantidad,
      })),
    },
    logistica: data.logistica.map((logistica) => ({
      codigo: logistica.codigo,
      cantidad: logistica.cantidad,
      tiempo_estimado: logistica.tiempo_estimado,
      saldo: logistica.saldo,
      faltan_baterias: logistica.faltan_baterias,
      productos_en_tienda: logistica.productos_en_tienda,
      detalle: logistica.detalle.map((detalle) => ({
        local: detalle.local,
        tipo: detalle.tipo,
        tiempo: detalle.tiempo,
        cantidad: detalle.cantidad,
      })),
    })),
  };
};
